/**
 * GMA-1617 (CompassCare Web 2/14) — Overview route container.
 *
 * Mounts the app-shell (WebShell) around the Overview dashboard (OverviewPage)
 * at /web/overview, wiring sidebar navigation to the router and exposing the
 * quick actions in the shell's top bar. This is the route scaffolding: the data
 * plumbing (live clients / alerts / KPI descriptors via computeKpis, and the
 * remaining quick-action flows) is a deliberate follow-up, so until then the
 * dashboard renders its fail-safe empty states inside a real, navigable frame.
 * Generate SITRep is wired (GMA-1624): it opens the SITRep board at
 * /web/intel/sitrep.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import QuickActions from "../../components/web/QuickActions";
import OverviewPage from "./OverviewPage";
import { computeKpis } from "./overviewModel";
import { DEMO_DATA_ENABLED, getDemoClients, getDemoAlerts, getDemoDevices } from "./demoData";

export default function WebOverviewRoute() {
  const navigate = useNavigate();
  const now = Date.now();
  // Demo build (commandcenter): seed the command-center dashboard so it's fully
  // interactive without the live clients/alerts/KPI APIs.
  const clients = DEMO_DATA_ENABLED ? getDemoClients(now) : [];
  const alerts = DEMO_DATA_ENABLED ? getDemoAlerts(now) : [];
  const kpis = DEMO_DATA_ENABLED
    ? computeKpis({ clients, alerts, devices: getDemoDevices(clients) })
    : [];
  return (
    <WebShell
      activeKey="overview"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Overview"
      actions={<QuickActions onGenerateSitrep={() => navigate("/web/intel/sitrep")} />}
    >
      <OverviewPage
        clients={clients}
        alerts={alerts}
        kpis={kpis}
        now={now}
        onGenerateSitrep={() => navigate("/web/intel/sitrep")}
      />
    </WebShell>
  );
}
